import { useEffect } from "react";
import { LoadingOverlay } from "@/apps/@components";

const CHANNEL_ID = process.env.REACT_APP_CHANNEL_ID;

export default function LineOAuthPage() {

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const liffUrl = `https://liff.line.me/${process.env.REACT_APP_LIFF_ID}`;

        const targetUrl = searchParams.get('_target_url');
        if (targetUrl) {
          const newLiffUrl = `${liffUrl}?_target_url=${encodeURIComponent(targetUrl)}`;
          const liffUrlEncode = encodeURIComponent(newLiffUrl);
          console.log(newLiffUrl);
          const url = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${CHANNEL_ID}&redirect_uri=${liffUrlEncode}&bot_prompt=aggressive&scope=profile&state=0`;
          window.location.href = url;
        }
        else {
          console.error('mgm auth redirectUrl is not set');
        }
      }, []);

    return (
        <LoadingOverlay visible={true} />
    )
}
